import {fragment} from './dom';
import {find, findAll} from './selector';
import {isString, toNode, toNodes} from './lang';

export function $(selector, context) {
    return !isString(selector)
        ? toNode(selector)
        : isHtml(selector)
            ? toNode(fragment(selector))
            : find(selector, context);
}

export function $$(selector, context) {
    return !isString(selector)
        ? toNodes(selector)
        : isHtml(selector)
            ? toNodes(fragment(selector))
            : findAll(selector, context);
}

function isHtml(str) {
    return str[0] === '<' || str.match(/^\s*</);
}



// WEBPACK FOOTER //
// ./node_modules/uikit/src/js/util/core.js